import React from "react";

import TradeVerticalPage from "../../../components/admin/Dashboard/trade/TradeVerticalPage";
import { TRADE_VERTICALS } from "../../../constants/tradeVerticals";

const TradeRisk = () => <TradeVerticalPage config={TRADE_VERTICALS.risk} />;

export default TradeRisk;
